type DayWords = { day: string; words: number };
const key = (date: Date) => `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`;
const shift = (day: string, amount: number) => { const date = new Date(`${day}T12:00:00`); date.setDate(date.getDate()+amount); return key(date); };

export function writingStats(rows: DayWords[], today: string, goal: number, options: { weekStart?: 0 | 1; restDays?: string[]; goalForDay?: (day: string) => number } = {}) {
  const byDay = new Map(rows.map(row=>[row.day,row.words]));
  const written = rows.filter(row=>row.words>0 && row.day<=today).sort((a,b)=>a.day.localeCompare(b.day));
  const total = written.reduce((sum,row)=>sum+row.words,0);
  const restDays = new Set((options.restDays ?? []).filter(day => day <= today));
  const goalForDay = options.goalForDay ?? (() => goal);
  const qualifies = (day: string) => (byDay.get(day) ?? 0) > 0 || restDays.has(day);
  let longestStreak = 0, run = 0;
  const first = written[0]?.day;
  if (first) for (let day = first; day <= today; day = shift(day, 1)) {
    if (!qualifies(day)) run = 0;
    else if ((byDay.get(day) ?? 0) > 0) run++;
    longestStreak = Math.max(longestStreak, run);
  }
  let streak = 0, cursor = qualifies(today) ? today : shift(today, -1);
  while (qualifies(cursor)) { if ((byDay.get(cursor) ?? 0) > 0) streak++; cursor = shift(cursor, -1); }
  const weekBegins = options.weekStart ?? 1;
  const weekDate = new Date(`${today}T12:00:00`); weekDate.setDate(weekDate.getDate() - ((weekDate.getDay() - weekBegins + 7) % 7));
  const weekStart=key(weekDate), monthStart=today.slice(0,7)+'-01';
  const sumSince=(first:string)=>written.filter(row=>row.day>=first).reduce((sum,row)=>sum+row.words,0);
  const best=written.reduce<DayWords|null>((best,row)=>!best||row.words>best.words ? row : best,null);
  const activity=Array.from({length:14},(_,i)=>{const day=shift(today,i-13); return {day,words:byDay.get(day)??0};});
  const daily=Array.from({length:90},(_,i)=>{const day=shift(today,i-89);return {day,words:byDay.get(day)??0,goal:goalForDay(day),rest:restDays.has(day)};});
  const previous7=written.filter(row=>row.day>=shift(today,-13)&&row.day<shift(today,-6)).reduce((sum,row)=>sum+row.words,0);
  const weekdays=Array.from({length:7},(_,weekday)=>{
    const dates=daily.filter(row=>(new Date(`${row.day}T12:00:00`).getDay()+6)%7===weekday);
    return {label:['Mon','Tue','Wed','Thu','Fri','Sat','Sun'][weekday],average:Math.round(dates.reduce((sum,row)=>sum+row.words,0)/dates.length)};
  });
  const months=Array.from({length:6},(_,i)=>{
    const date=new Date(`${today}T12:00:00`);date.setDate(1);date.setMonth(date.getMonth()+i-5);
    const month=key(date).slice(0,7), matching=written.filter(row=>row.day.startsWith(month));
    return {month,words:matching.reduce((sum,row)=>sum+row.words,0),days:matching.length};
  });
  return {weekBegins,total,days:written.length,streak,longestStreak,today:byDay.get(today)??0,week:sumSince(weekStart),month:sumSince(monthStart),last7:sumSince(shift(today,-6)),
    average:written.length ? Math.round(total/written.length) : 0,best,goalDays:written.filter(row=>goalForDay(row.day)>0 && row.words>=goalForDay(row.day)).length,activity,daily,previous7,weekdays,months};
}
